import { registerDecorator, ValidationOptions } from 'class-validator';

export const IsPositiveInteger = (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) => {
  registerDecorator({
    name: 'IsPositiveInteger',
    target: object.constructor,
    propertyName: propertyName,
    options: validationOptions,
    validator: {
      validate: (currentValue: any) => {
        return currentValue > 0;
      },
      defaultMessage: () => 'Value should be greater than 0',
    },
  });
};
